import { render, staticRenderFns } from "./HaveDingding.vue?vue&type=template&id=a4dadb60&scoped=true&"
import script from "./HaveDingding.vue?vue&type=script&lang=js&"
export * from "./HaveDingding.vue?vue&type=script&lang=js&"
import style0 from "./HaveDingding.vue?vue&type=style&index=0&id=a4dadb60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dadb60",
  null
  
)

export default component.exports